import { from } from "rxjs";
import { concatMap, ignoreElements } from "rxjs/operators";
import { endWith } from "./endWith";
export function concatTap(next) {
    return (source) => source.pipe(concatMap((value) => from(next(value)).pipe(ignoreElements(), endWith(value))));
}
//# sourceMappingURL=concatTap.js.map